import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss']
})
export class NavigationMenuComponent implements OnInit {
  isHome: boolean;

  constructor(private _route: Router) {}

  ngOnInit() {
    this._route.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.isHome = e.url === '/' || e.url.indexOf('home') > 0;
      }
    });
  }
}
